import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import logoSrc from "../assets/images/logo.png";
import ContactUS from "./ContactUS";
import * as mq from "../styles/mediaQueries";

function NavBar() {
  return (
    <Section>
      <Link to="/">
        <Logo src={logoSrc} alt="fyntune" />
      </Link>
      <div
        css={`
        ${mq.sm} {
          display: none;
        }
      `}
      >
        <ContactUS />
      </div>
    </Section>
  );
}

export default NavBar;

const Logo = styled.img`
  width: 100%;
  /* height: 40px; */
  max-width: 11.625em;
`;

const Section = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 0.75em 5% 0.625em;
  transition: all 0.4s ease-out;
  /* box-shadow: 0 13px 35px -12px rgb(35 35 35 / 10%); */

  ${mq.sm} {
    padding-top: 1.6em;
    position: absolute;
  }
`;
